var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.disabled ? _vm.startedLabel : _vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }